const AVAILABILITY_NAMESPACES = ["/availability", "/mobile/availability"] as const;

export default AVAILABILITY_NAMESPACES;
